import { API_REQUEST } from '../actions/apiActions';
import { ADD_UI_MSG } from '../actions/uiActions';
import { isProd } from '../../utilities/env';
export const controller = new AbortController();
const { signal } = controller;

/**
 * Function to determine how to process the responses from the api call. The function reads the response headers and calls the appropriate function to process the data
 * @param {object} response - The content of the response from the api call
 * @fires handleJSONResponse - Function to process the content into json
 * @fires handleTextResponse - Function to process the content into plain text
 * @returns {*} - Returned data determined by the content type as defined by the response headers
 */
export function handleResponse(response) {
  console.log(response)
  let contentType = response.headers.get('content-type');
  let status = response.status;
  if (status === 204) {
    // When sending a DELETE call, the server will return a 204 response with no payload. This checks for that response and returns true to let the success middleware know that the request was successful
    return true;
  } else {
    if (contentType) {
      if (contentType.includes('application/json')) {
        return handleJSONResponse(response);
      } else if (contentType.includes('text/html')) {
        return handleTextResponse(response);
      } else if (contentType.includes('text/csv')) {
        return handleCSVResponse(response);
      } else {
        // Other response types as necessary. I haven't found a need for them yet though.
        throw new Error(`Sorry, content-type ${contentType} not supported`);
      }
    } else {
      return true;
    }
  }
}

/**
 * Function to convert the content of the response to json
 * @param {object} response - Content returned from API
 * @returns {json} - Converted content
 */
export function handleJSONResponse(response) {
  return response.json().then((json) => {
    if (response.ok) {
      return json;
    } else {
      return Promise.reject(
        Object.assign({}, json, {
          status: response.status,
          statusText: response.statusText,
        })
      );
    }
  });
}

/**
 * Function to convert the content of the response to plain text
 * @param {object} response - Content returned from API
 * @returns {text} - Converted content
 */
export function handleTextResponse(response) {
  return response.text().then((text) => {
    if (response.ok) {
      return text;
    } else {
      return Promise.reject({
        status: response.status,
        statusText: response.statusText,
        err: text,
      });
    }
  });
}

/**
 * Function to convert the content of the response to plain text
 * @param {object} response - Content returned from API
 * @returns {text} - Converted content
 */
export function handleCSVResponse(response) {
  return response.text().then((text) => {
    if (response.ok) {
      return text;
    } else {
      return Promise.reject({
        status: response.status,
        statusText: response.statusText,
        err: text,
      });
    }
  });
}

/**
 * Function to trigger the API call based on the information sent through the action
 * @param {object} action - The action contents coming from the action creator
 * @fires handleResponse - Function to process returned content
 * @fires dispatch#onSuccess - Dispatches the action passed in the initial action to be called on successful completion of the api call
 * @fires dispatch#onError - Dispatches the action passed in the initial action to be called when an error occurs
 */
export const api = ({ dispatch }) => (next) => (action) => {
  if (action.type === API_REQUEST) {
    const { method, url, onSuccess, onError, auth, body, csv } = action.meta;
    const isFormData = (body instanceof FormData)
    let messageBody;
    if (!body) {
      messageBody = null;
    } else if (csv) {
      messageBody = action.payload;
    } 
    else if (isFormData){
      messageBody = body
    }
    else {
      messageBody = JSON.stringify(action.payload);
    }
    /**
     * Fetch function to request data from the api.
     * @description - Fetch returns a javascript promise so the processing is handled in the .then() statements chaned to the initial request
     * @param {string} url - Url to request data from
     * @param {string} method - Type of api call to make (GET, POST, PATCH, DELETE)
     * @param {*} messageBody - Contents to be included in the api call body. Null for GET requests, JSON for all others
     * @param {string} onSuccess - Name of action to be run on successful completion of api call
     * @param {string} onError - Name of action to be run on error
     */
    let headers = {
      'Content-Type': 'application/json',
    };
    if (isFormData){
      headers = {};
    };
    if (auth) {
      headers = {
        ...headers,
        Authorization: 'Token ' + auth,
      };
    }
    if (csv) {
      headers = {
        ...headers,
        'Content-Type': 'text/csv',
      };
    }
    fetch(url, {
      signal,
      method: method,
      headers: headers,
      body: messageBody,
    })
      .then(handleResponse)
      .then(
        (data) =>
          dispatch({ type: onSuccess, payload: data, meta: action.meta })
        // This is set up to return all of the information sent for the original api call
        // this allows passing additional metadata that might be used in a later action or
        // middleware. By returning the entire meta object, this allows anything to be passed
        // through without having to continually expand the api middleware for every use case.
      )
      .catch((error) => {
        let status = error.status;
        if (status === 401) {
          // If the user token is rejected, push the interface to the log out screen to clear the Redux store and return them to the Sara login screen
          if (isProd()) {
            dispatch({
              type: ADD_UI_MSG,
              payload: { redirect: '/logout', status: 'invalidToken' },
            });
          }
        } else {
          dispatch({
            type: onError,
            payload: error,
            meta: action.meta,
            originalPayload: action.payload,
          });
        }
      });
  }
  return next(action);
};
// export const api2 = ({ dispatch }) => (next) => (action) => {
//   if (action.type === API_REQUEST2) {
//     console.log('in api2');
//     const { method, url, onSuccess, onError, auth, body } = action.meta;
//     // let messageBody;
//     // if (!body) {
//     //   messageBody = null;
//     // }
  
   
//     // let headers = {
//     //   'Content-Type': 'multipart/form-data',
//     // };
//    let headers = {};
//     if (auth) {
//     headers = {
//       // ...headers,
//       Authorization: 'Token ' + auth,
//     };
//     }

//     fetch(url, {
//     signal,
//     method: method,
//     headers: headers,
//     body: body,
//     })
//     .then(handleResponse)
//     .then(
//       (data) =>
//         dispatch({ type: onSuccess, payload: data, meta: action.meta })
//       // This is set up to return all of the information sent for the original api call
//       // this allows passing additional metadata that might be used in a later action or
//       // middleware. By returning the entire meta object, this allows anything to be passed
//       // through without having to continually expand the api middleware for every use case.
//     )
//     .catch((error) => {
//       let status = error.status;
//       if (status === 401) {
//         // If the user token is rejected, push the interface to the log out screen to clear the Redux store and return them to the Sara login screen
//         if (process.env.NODE_ENV === 'production') {
//           dispatch({
//             type: ADD_UI_MSG,
//             payload: { redirect: '/logout', status: 'invalidToken' },
//           });
//         }
//       } else {
//         dispatch({
//           type: onError,
//           payload: error,
//           meta: action.meta,
//           originalPayload: action.payload,
//         });
//       }
//     });
// }
// return next(action);
// }

export default api;

// export const apiMdl = [
//   api,
//   api2,
// ]
